<script>
import GenericCrud from "@forms/GenericCrud.vue";
import api from "@services/api";

export default {
  extends: GenericCrud,
  props: {
    table: {
      type: String,
      default: "Fatura"
    }
  },
  data: () => ({
    contratoList: {}
  }),
  created() {
    this.getContratoList();
  },
  methods: {
    getContratoList() {
      api
        .get(`crud/Contrato`, {
          params: {
            sortBy: "descricao",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.contratoList = response.data["data"]));
    }
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <div class="row">
        <b-form-group
          id="input-group-1"
          label="Ano Mês"
          label-for="anomes"
          class="col-md-4"
        >
          <b-form-input
            id="anomes"
            v-model="item.anoMes"
            :disabled="!this.editForm"
            type="number"
            min="0"
            max="9999999"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-1"
          label="NFSe"
          label-for="nfSe"
          class="col-md-8"
        >
          <b-form-input
            id="nfSe"
            v-model="item.nfSe"
            :disabled="!this.editForm"
            type="text"
          ></b-form-input>
        </b-form-group>
      </div>
      <b-form-group id="input-group-2" label="Contrato" label-for="contratoId">
        <b-form-select
          id="contratoId"
          v-model="item.contratoId"
          :disabled="!this.editForm"
          required
        >
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in contratoList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.descricao }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>
      <div class="row">
        <b-form-group
          id="input-group-1"
          label="Data"
          label-for="data"
          class="col-md-4"
        >
          <b-form-datepicker
            id="data"
            v-model="item.data"
            :disabled="!this.editForm"
            required="true"
            placeholder="Selecione uma data"
            :hide-header="true"
          ></b-form-datepicker>
        </b-form-group>
        <b-form-group
          id="input-group-1"
          label="Data de vencimento"
          label-for="dataVencimento"
          class="col-md-4"
        >
          <b-form-datepicker
            id="dataVencimento"
            v-model="item.dataVencimento"
            :disabled="!this.editForm"
            placeholder="Selecione uma data"
            :hide-header="true"
          ></b-form-datepicker>
        </b-form-group>
        <b-form-group
          id="input-group-1"
          label="Data de pagamento"
          label-for="dataPagamento"
          class="col-md-4"
        >
          <b-form-datepicker
            id="dataPagamento"
            v-model="item.dataPagamento"
            :disabled="!this.editForm"
            placeholder="Selecione uma data"
            :hide-header="true"
          ></b-form-datepicker>
        </b-form-group>
      </div>

      <div class="row">
        <b-form-group
          id="input-group-1"
          label="Valor (R$)"
          label-for="valor"
          class="col-md-6"
        >
          <b-form-input
            id="valor"
            v-model="item.valor"
            :disabled="!this.editForm"
            type="number"
            step="0.01"
            min="0.00"
            max="9999999.00"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Horas"
          label-for="cargaHoraria"
          class="col-md-6"
        >
          <b-form-input
            id="horas"
            v-model="item.horas"
            :disabled="!this.editForm"
            type="number"
            step="0.01"
            min="0.00"
            max="9999.00"
          ></b-form-input>
        </b-form-group>
      </div>

      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="danger" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
    </b-form>
    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
